import React from "react";

const SvgSort = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3907_23610)">
      <path
        d="M6.3488 0.9452V0.546819C6.3488 0.326793 6.17045 0.148438 5.95042 0.148438H0.398381C0.178355 0.148438 0 0.326793 0 0.546819V0.9452C0 1.16523 0.178355 1.34358 0.398381 1.34358H5.95042C6.17045 1.34358 6.3488 1.16523 6.3488 0.9452Z"
        fill="white"
      />
      <path
        d="M5.2023 2.6582H0.398381C0.178355 2.6582 0 2.83656 0 3.05658V3.45497C0 3.67499 0.178355 3.85335 0.398381 3.85335H5.2023C5.42233 3.85335 5.60068 3.67499 5.60068 3.45497V3.05658C5.60068 2.83656 5.42233 2.6582 5.2023 2.6582Z"
        fill="white"
      />
      <path
        d="M4.4541 5.16797H0.398381C0.178355 5.16797 0 5.34632 0 5.56635V5.96473C0 6.18476 0.178355 6.36311 0.398381 6.36311H4.4541C4.67413 6.36311 4.85248 6.18476 4.85248 5.96473V5.56635C4.85248 5.34632 4.67413 5.16797 4.4541 5.16797Z"
        fill="white"
      />
      <path
        d="M3.70594 7.95703H0.398381C0.178355 7.95703 0 8.13539 0 8.35541V8.75379C0 8.97382 0.178355 9.15217 0.398381 9.15217H3.70594C3.92593 9.15217 4.10432 8.97382 4.10432 8.75379V8.35541C4.10432 8.13539 3.92597 7.95703 3.70594 7.95703Z"
        fill="white"
      />
      <path
        d="M2.95774 10.4668H0.398381C0.178355 10.4668 0 10.6452 0 10.8652V11.2636C0 11.4836 0.178355 11.6619 0.398381 11.6619H2.95774C3.17773 11.6619 3.35612 11.4836 3.35612 11.2636V10.8652C3.35612 10.6452 3.17777 10.4668 2.95774 10.4668Z"
        fill="white"
      />
      <path
        d="M11.883 8.6396L11.6013 8.35791C11.5266 8.28321 11.4252 8.24122 11.3196 8.24122C11.2139 8.24122 11.1126 8.28321 11.0378 8.35791L9.66769 9.72806V0.746037C9.66769 0.526012 9.48934 0.347656 9.26931 0.347656H8.87093C8.6509 0.347656 8.47255 0.526012 8.47255 0.746037V9.72802L7.1024 8.35787C7.02766 8.28317 6.92635 8.24118 6.8207 8.24118C6.71505 8.24118 6.6137 8.28317 6.53901 8.35787L6.25727 8.63956C6.10174 8.79513 6.10174 9.04739 6.25727 9.20295L8.78843 11.7341C8.86623 11.8119 8.96818 11.8508 9.07012 11.8508C9.17207 11.8508 9.27405 11.8119 9.35182 11.7341L11.883 9.20295C12.0385 9.04739 12.0385 8.79513 11.883 8.6396Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3907_23610">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgSort;
